import { render } from "./Index.vue?vue&type=template&id=5e8b6786&scoped=true"
import script from "./Index.vue?vue&type=script&scoped=true&lang=js"
export * from "./Index.vue?vue&type=script&scoped=true&lang=js"

import "./Index.vue?vue&type=style&index=0&id=5e8b6786&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8b6786"]])

export default __exports__